import type { ExtendedThalamosUser } from "@thalamos/aspire-common";

export function userCanEditMhaStatus(
  user: ExtendedThalamosUser | undefined,
): boolean {
  const organisationPatientStateEnabled =
    user?.sessionOrganisationConfiguration?.patientStateEnabled ?? false;

  const isMhaMember =
    user?.sessionContext?.teamType === "mha" &&
    user?.sessionContext?.role === "member";

  return organisationPatientStateEnabled && isMhaMember;
}
